// extracted by mini-css-extract-plugin
module.exports = {"th":"TpMYaVPd","th-text":"_14BQh1f3","left":"_2R7ucjCT","right":"J1-QHxyG","center":"iLfuXeRs"};